import { RouterConfig } from "@shared/lib/routerConfig";

export const menuItems = [
    { title: "Автомобили", link: RouterConfig.CATALOG },
    { title: "Страхование", link: RouterConfig.INSURANCE },
    { title: "Оценка авто", link: RouterConfig.ANALYTICS },
    { title: "Документы", link: RouterConfig.GENERATOR_DKP },
    { title: "Блог", link: RouterConfig.BLOG }
];